import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
}

export default function AlignMiddleIcon(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "26.999"}
      height={height || "30"}
      viewBox="0 0 26.999 30"
    >
      <rect
        id="Rectangle_1952"
        data-name="Rectangle 1952"
        width="26.999"
        height="30"
        rx="5"
        fill="#f9f9f9"
      />
      <path
        id="Union_25"
        data-name="Union 25"
        d="M.5,14a.5.5,0,0,1-.5-.5v-.75a.5.5,0,0,1,.5-.5h14a.5.5,0,0,1,.5.5v.75a.5.5,0,0,1-.5.5Zm2-4.064a.5.5,0,0,1-.5-.5v-.75a.5.5,0,0,1,.5-.5h10a.5.5,0,0,1,.5.5v.75a.5.5,0,0,1-.5.5ZM.5,5.872a.5.5,0,0,1-.5-.5V4.622a.5.5,0,0,1,.5-.5h14a.5.5,0,0,1,.5.5v.751a.5.5,0,0,1-.5.5Zm2-4.122a.5.5,0,0,1-.5-.5V.5A.5.5,0,0,1,2.5,0h10a.5.5,0,0,1,.5.5V1.25a.5.5,0,0,1-.5.5Z"
        transform="translate(6 8)"
        fill="#707070"
      />
    </svg>
  );
}
